import React from "react";
import { Accordion, Button, Col, Pagination, Row } from "react-bootstrap";
import HelpButton from "../../HelpContent/HelpButton";
import MyBadge from "../MyBadge";
import ArrowRightIcon from "../../../assets/icons/arrow_right-01.svg2";
import TickIcon from "../../../assets/icons/tick.svg2";
import MovableIcon from "../../../assets/icons/movable.svg2";
import AddCircleIcon from "../../../assets/icons/add_circle-01.svg2";
import BoomerangIcon from "../../../assets/icons/boomerang_element-01.svg2";
import MappingIcon from "../../../assets/icons/data_mapping-01.svg2";
import AssetIcon from "../../../assets/icons/asset-01.svg2";

import Select from "react-select";
import MyPagination from "../MyPagination";
import MySelect from "../MySelect";

export default function AssetsMapping() {
  return (
    <div>
      <div>
        <Row className="mb-5 mt-4 p-3 ">
          <div className="col-12 col-lg">
            <div className="ms-2">
              <span className="fs-4 fw-bold ">
                Mapping your fields to system fields
              </span>
              <span className="text-secondary ms-2">
                <HelpButton />
              </span>
            </div>
            <div className="text-secondary ms-2">
              Lorem ipsum dolor sit amet consectetur adipisicing elit.
            </div>
          </div>
          <div className="col-12 col-lg-auto">
            <span className="fw-bold">
              <MyBadge count={2} />
            </span>
            <span className="fw-bold ms-2 fs-4">
              Assets ready to configure/ map
            </span>
          </div>
        </Row>

        <Accordion defaultActiveKey="0">
          <Accordion.Item
            eventKey="0"
            className="bg-purple-gradient-darker-reverse rounded-4 overflow-hidden"
          >
            <Accordion.Header>
              {" "}
              <Row className="align-items-center my-3 flex-grow-1 ">
                <Col xs={5}>
                  <div className=" d-flex">
                    <div className="fw-bold ms-2 fs-4">
                      Import /Map Asset:
                      <HelpButton />
                    </div>
                    <div className="ms-2">
                      <span className="fw-bold">
                        <MyBadge count={2} />
                      </span>
                      <span className="fw-bold ms-2 fs-4">
                        fields that still need mapping
                      </span>
                    </div>
                  </div>
                </Col>
                <Col xs={1}></Col>
                <Col xs={5}>
                  <div className="fw-bold ms-2 fs-4 d-flex ">
                    System repository to import to: <HelpButton />
                  </div>
                </Col>
              </Row>
            </Accordion.Header>
            <Accordion.Body>
              <div className="mb-5 mt-4 p-3 align-items-end bg-purple-gradient-darker-reverse m-2 rounded-3">
                <Row className="align-items-center my-3">
                  <Col xs={5}>
                    <Accordion defaultActiveKey="0">
                      <Accordion.Item
                        eventKey="0"
                        className="rounded-4 overflow-hidden"
                      >
                        <Accordion.Header>
                          <div className="row align-items-start">
                            <div className="col-2 text-purple">
                              <AssetIcon width={50} />
                            </div>
                            <div className="col-10 my-2">
                              <div className="d-flex align-items-start">
                                <h5 className="fw-bold">Main Building (HQ)</h5>
                                <Button
                                  type="submit"
                                  size="sm"
                                  className="btn btn-colored-reverse rounded-pill fw-bold ms-2 py-0"
                                >
                                  4 FIELDS FOUND
                                </Button>
                              </div>
                              <h6 className="small opacity-50 ">
                                Lorem ipsum dolor sit amet consectetur...
                              </h6>
                            </div>
                          </div>
                        </Accordion.Header>
                        <Accordion.Body>
                          <div className="bg-white rounded-3  row">
                            <div className="col-10 offset-2 text-purple">
                              <span className="d-flex align-items-center">
                                <TickIcon width={15} />
                                <h5 className=" p-1 small">geo_location</h5>
                              </span>
                              <span className="d-flex align-items-center">
                                <TickIcon width={15} />
                                <h5 className=" p-1 small">sla_guarantee</h5>
                              </span>
                              <span className="d-flex align-items-center">
                                <TickIcon width={15} />
                                <h5 className=" p-1 small">category</h5>
                              </span>
                              <span className="d-flex align-items-center">
                                <TickIcon width={15} />
                                <h5 className=" p-1 small">contacts_groups</h5>
                              </span>
                            </div>
                          </div>
                        </Accordion.Body>
                      </Accordion.Item>
                    </Accordion>
                  </Col>
                  <Col xs={1} className="text-center">
                    <ArrowRightIcon
                      className="text-purple me-2"
                      width={50}
                      height={100}
                    />
                  </Col>
                  <Col xs={5}>
                    <Accordion>
                      <Accordion.Item
                        eventKey="1"
                        className="rounded-4 overflow-hidden"
                      >
                        <Accordion.Header>
                          <div className="row align-items-start">
                            <div className="col-2 text-purple ">
                              <AssetIcon width={50} className="me-3"/>
                            </div>
                            <div className="my-2 col-10 ">
                              <div className="d-flex align-items-start">
                                <h5 className="fw-bold ms-2 ">Repository One</h5>
                              </div>
                              <h6 className="small opacity-50 ms-2">
                                Lorem ipsum dolor sit amet consectet...
                              </h6>
                            </div>
                          </div>
                        </Accordion.Header>
                        <Accordion.Body>
                          <div className="bg-white rounded-3 mt-2"></div>
                        </Accordion.Body>
                      </Accordion.Item>
                    </Accordion>
                  </Col>
                  <Col xs={1}>
                    <TickIcon className="text-purple" width={20} />
                  </Col>
                </Row>

                <div className="fw-bold ms-2 fs-4 d-flex py-2 ">
                  <MappingIcon width={30} className="me-2 " /> Map this assets
                  fields to system fields:
                </div>

                <Row>
                  <Col xs={5}>
                    <div className="d-flex gap-3 align-items-center mt-2">
                      <div className="flex-grow-1">
                        <MySelect
                          options={[
                            { value: "geo", label: "geo_location" },
                            { value: "sla_guarantee", label: "Sla guarantee" },
                            { value: "category", label: "Category" },
                            {
                              value: "contacts_groups",
                              label: "contacts_groups",
                            },
                          ]}
                          placeholder="geo_location"
                        />
                      </div>
                    </div>
                  </Col>
                  <Col xs={1} className="text-center">
                    <ArrowRightIcon className="text-purple me-2" width={50} />
                  </Col>
                  <Col xs={5}>
                    <div className="d-flex align-items-center gap-3 mt-2  ">
                      <div className="flex-grow-1 ">
                        <MySelect
                          options={[
                            {
                              value: "geo_location",
                              label: (
                                <div>
                                  <BoomerangIcon className="me-2" width={30} />
                                  <span className=" me-2">GeoLocation</span>
                                </div>
                              ),
                            },
                            {
                              value: "systemlastName",
                              label: " System Last Name",
                            },
                            { value: "sla_guarantee", label: " Sla Guarantee" },
                            {
                              value: "category",
                              label: "Category",
                            },
                          ]}
                          placeholder={
                            <div>
                              <BoomerangIcon className=" me-2" width={30} />
                              <span className=" me-2">Geo Location</span>
                            </div>
                          }
                        />
                      </div>
                    </div>
                  </Col>
                  <Col xs={1} className="d-flex gap-3 mt-3">
                    <div>
                      <TickIcon className="text-purple ms-2 " width={20} />
                    </div>
                    <div>
                      <MovableIcon className=" opacity-50" width={20} />
                    </div>
                  </Col>
                  <hr className="mt-3 text-secondary" />
                </Row>
                <Row>
                  <Col xs={5}>
                    <div className="d-flex gap-3 align-items-center mt-2">
                      <div className="flex-grow-1">
                        <MySelect
                          options={[
                            { value: "geo", label: "geo_location" },
                            { value: "sla_guarantee", label: "Sla guarantee" },
                            { value: "category", label: "Category" },
                            {
                              value: "contacts_groups",
                              label: "contacts_groups",
                            },
                          ]}
                          placeholder="geo_location"
                        />
                      </div>
                    </div>
                  </Col>
                  <Col xs={1} className="text-center">
                    <ArrowRightIcon className="text-purple me-2" width={50} />
                  </Col>
                  <Col xs={5}>
                    <div className="d-flex align-items-center gap-3 mt-2  ">
                      <div className="flex-grow-1 ">
                        <MySelect
                          options={[
                            {
                              value: "geo_location",
                              label: (
                                <div>
                                  <BoomerangIcon className=" me-2" width={30} />
                                  <span className=" me-2">GeoLocation</span>
                                </div>
                              ),
                            },
                            {
                              value: "systemlastName",
                              label: " System Last Name",
                            },
                            { value: "sla_guarantee", label: " Sla Guarantee" },
                            {
                              value: "category",
                              label: "Category",
                            },
                          ]}
                          placeholder={
                            <div>
                              <BoomerangIcon className=" me-2" width={30} />
                              <span className=" me-2">Geo Location</span>
                            </div>
                          }
                        />
                      </div>
                    </div>
                  </Col>
                  <Col xs={1} className="d-flex gap-3 mt-3">
                    <div>
                      <TickIcon className="text-purple ms-2 " width={20} />
                    </div>
                    <div>
                      <MovableIcon className=" opacity-50" width={20} />
                    </div>
                  </Col>
                  <hr className="mt-3 text-secondary" />
                </Row>
                <Row>
                  <Col xs={5}>
                    <div className="d-flex gap-3 align-items-center mt-2">
                      <div className="flex-grow-1">
                        <MySelect
                          options={[
                            { value: "geo", label: "geo_location" },
                            { value: "sla_guarantee", label: "Sla guarantee" },
                            { value: "category", label: "Category" },
                            {
                              value: "contacts_groups",
                              label: "contacts_groups",
                            },
                          ]}
                          placeholder="geo_location"
                        />
                      </div>
                    </div>
                  </Col>
                  <Col xs={1} className="text-center">
                    <ArrowRightIcon className="text-purple me-2" width={50} />
                  </Col>
                  <Col xs={5}>
                    <div className="d-flex align-items-center gap-3 mt-2  ">
                      <div className="flex-grow-1 ">
                        <MySelect
                          options={[
                            {
                              value: "geo_location",
                              label: (
                                <div>
                                  <BoomerangIcon className=" me-2" width={30} />
                                  <span className=" me-2">GeoLocation</span>
                                </div>
                              ),
                            },
                            {
                              value: "systemlastName",
                              label: " System Last Name",
                            },
                            { value: "sla_guarantee", label: " Sla Guarantee" },
                            {
                              value: "category",
                              label: "Category",
                            },
                          ]}
                          placeholder={
                            <div>
                              <BoomerangIcon className=" me-2" width={30} />
                              <span className=" me-2">Geo Location</span>
                            </div>
                          }
                        />
                      </div>
                    </div>
                  </Col>
                  <Col xs={1} className="d-flex gap-3 mt-3">
                    <div>
                      <TickIcon className="text-purple ms-2 " width={20} />
                    </div>
                    <div>
                      <MovableIcon className=" opacity-50" width={20} />
                    </div>
                  </Col>
                  <hr className="mt-3 text-secondary" />

                  <div className="ms-2 px-3">
                    <MyPagination total={50} onPaginate={() => {}} />
                  </div>
                </Row>
              </div>
            </Accordion.Body>
          </Accordion.Item>
          <Accordion.Item
            eventKey="1"
            className="bg-purple-gradient-darker-reverse rounded-4 overflow-hidden"
          >
            <Accordion.Header>
              <Row className="flex-grow-1">
                <Col xs={5}>
                  <div className=" d-flex">
                    <div className="fw-bold ms-2 fs-4">
                      Import /Map Asset:
                      <HelpButton />
                    </div>
                    <div className="ms-2">
                      <span className="fw-bold">
                        <MyBadge count={8} />
                      </span>
                      <span className="fw-bold ms-2 fs-4">
                        fields that still need mapping
                      </span>
                    </div>
                  </div>
                </Col>
                <Col xs={1}></Col>
                <Col xs={5}>
                  <div className="fw-bold ms-2 fs-4 d-flex ">
                    System repository to import to: <HelpButton />
                  </div>
                </Col>
              </Row>
            </Accordion.Header>
            <Accordion.Body>
              <div className="mb-5 mt-4 p-3 align-items-end bg-purple-gradient-darker m-3 rounded-3">
                <Row className="align-items-center my-3">
                  <Col xs={5}>
                    <Accordion defaultActiveKey="0" className="mt-3">
                      <Accordion.Item
                        eventKey="0"
                        className="rounded-4 overflow-hidden"
                      >
                        <Accordion.Header>
                          <div className="row align-items-start">
                            <div className="col-2 text-purple">
                              <AssetIcon width={50} className="me-3" />
                            </div>
                            <div className="col-10 my-2">
                              <div className="d-flex align-items-start">
                                <h5 className="fw-bold ms-2">Server (Node 1)</h5>
                                <Button
                                  type="submit"
                                  size="sm"
                                  className="btn btn-colored-reverse rounded-pill fw-bold ms-2 py-0"
                                >
                                  8 FIELDS FOUND
                                </Button>
                              </div>
                              <h6 className="small opacity-50 ms-2 ">
                                Lorem ipsum dolor sit amet consectetur...
                              </h6>
                            </div>
                          </div>
                        </Accordion.Header>
                        <Accordion.Body>
                          <div className="bg-white rounded-3  row">
                            <div className="col-10 offset-2 text-purple">
                              <span className="d-flex align-items-center">
                                <TickIcon width={15} />
                                <h5 className=" p-1 small">geo_location</h5>
                              </span>
                              <span className="d-flex align-items-center">
                                <TickIcon width={15} />
                                <h5 className=" p-1 small">sla_guarantee</h5>
                              </span>
                              <span className="d-flex align-items-center">
                                <TickIcon width={15} />
                                <h5 className=" p-1 small">category</h5>
                              </span>
                              <span className="d-flex align-items-center">
                                <TickIcon width={15} />
                                <h5 className=" p-1 small">contacts_groups</h5>
                              </span>
                            </div>
                          </div>
                        </Accordion.Body>
                      </Accordion.Item>
                    </Accordion>
                  </Col>
                  <Col xs={1} className=" align-items-center text-center">
                    <ArrowRightIcon
                      className="text-purple me-2"
                      width={50}
                      height={100}
                    />
                  </Col>
                  <Col xs={5} className="d-flex align-items-center gap-3">
                    <div className="flex-grow-1">
                      <Accordion>
                        <Accordion.Item
                          eventKey="1"
                          className="mt-3 rounded-4 overflow-hidden"
                        >
                          <Accordion.Header>
                            <div className=" row align-items-start me-3 ">
                              <div className="col-2 text-purple">
                                <AssetIcon width={50} className="me-3 " />
                              </div>
                              <div className="my-2 col-10">
                                <div className="d-flex align-items-start">
                                  <h5 className="fw-bold ms-2">Repository Two</h5>
                                </div>
                                <h6 className="small opacity-50 ms-2">
                                  Lorem ipsum dolor sit amet consectet...
                                </h6>
                              </div>
                            </div>
                          </Accordion.Header>
                          <Accordion.Body>
                            <div className="bg-white rounded-3 mt-3"></div>
                          </Accordion.Body>
                        </Accordion.Item>
                      </Accordion>
                    </div>
                  </Col>
                  <Col xs={1}>
                    <div>
                      <TickIcon className="text-purple ms-2 me-3" width={20} />
                    </div>
                    <div className="me-4"></div>
                  </Col>
                </Row>
              </div>
            </Accordion.Body>
          </Accordion.Item>
        </Accordion>
        <div className="ms-3 px-3">
          <MyPagination total={50} onPaginate={() => {}} />
        </div>
        <div className="d-flex justify-content-end p-3">
          <Button
            type="submit"
            className="btn bg-white rounded-pill border-0 px-4"
          >
            <AddCircleIcon className="text-purple rounded-50 me-3" width={25} />
            <span className="text-black">Create new field</span>
          </Button>
        </div>
        <hr className="mt-3 text-secondary" />
      </div>
    </div>
  );
}
